import * as _4 from 'lodash4';
import { APModel } from '../../../../../global/models/ap_model';
import { IPlanFeedbackGenericSlotBuilder } from '../../builders/plan_feedback_generic_slot_builder';

class PlanFeedbackTermProgramSlotTileController {
  private programSlot: IPlanFeedbackGenericSlotBuilder;
  private hasComment: boolean;
  private uniqueId: string;

  $onInit() {
    this.uniqueId = _4.uniqueId();
  }

  $onChanges() {
    this.hasComment = !_4.isEmpty(this.programSlot.comment);
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackTermProgramSlotTile', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term_program_slot_tile/plan_feedback_term_program_slot_tile.html',
  bindings: {
    programSlot: '<'
  },
  controller: PlanFeedbackTermProgramSlotTileController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term_program_slot_tile/plan_feedback_term_program_slot_tile.ts